<template>
  <base-dialog class="select-print-template" :visible.sync="visible" width="640px">
    <template #header>
      <div>选择打印模板</div>
    </template>
    <div
      v-if="!templateList || templateList.length === 0"
      v-loading="loadingTemplates"
      class="empty"
    >
      该工作表暂无打印模板
    </div>
    <el-table
      v-else
      :data="templateList"
      highlight-current-row
      @current-change="handleCurrentChange"
      style="width: 100%"
    >
      <el-table-column width="100" align="center">
        <template slot-scope="scope">
          <div class="circular" :class="{ active: scope.row.id === selTemplate }"></div>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="模板名称" align="center"></el-table-column>
      <el-table-column prop="desc" label="描述" align="center"></el-table-column>
    </el-table>
    <template v-slot:footer>
      <span class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="submit">打 印</el-button>
      </span>
    </template>
    <tinymce v-if="visible" ref="tinymce" class="tinymce" :value="editorValue"></tinymce>
  </base-dialog>
</template>

<script>
import { getList, print } from "@/api/appManage/print-template"
import Tinymce from "@/components/Tinymce"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import { batchPrint } from "@/api/sheet/batch"
import { loadingService } from "@/utils/ui"
export default {
  name: "selectPrintTemplate",
  components: {
    Tinymce,
    BaseDialog
  },
  data() {
    return {
      visible: false,
      dataId: null,
      sheetId: null,
      appId: null,
      batchData: null,
      templateList: [],
      loadingTemplates: false,
      selTemplate: "",
      editorValue: ""
    }
  },
  methods: {
    // 打开
    open({ dataId, sheetId, appId, batchData }) {
      Object.assign(this, { dataId, sheetId, appId, batchData })
      this.visible = true
      this.selTemplate = ""
      this.templateList = []
      this.loadingTemplates = true
      getList({ type: "sheetId", id: sheetId })
        .then(templateList => {
          this.templateList = templateList
          this.selTemplate = templateList?.[0]?.id
        })
        .finally(() => (this.loadingTemplates = false))
    },
    // 打印
    async submit() {
      if (!this.selTemplate) {
        this.$message.warning({ message: "请选择一个打印模板后再打印", offset: 100 })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      })
      this.editorValue = this.batchData
        ? await batchPrint(this.batchData, this.selTemplate)
        : await print({
            dataId: this.dataId,
            templateId: this.selTemplate,
            appId: this.appId
          })
      // 如果有附件图片，追加样式信息
      this.editorValue = this.editorValue
        .split('class="mce-file-img"')
        .join('style="width:200px !important"')
      this.$emit("dealLast")
      await this.$nextTick()
      this.$refs.tinymce.preview()
      loading.close()
    },
    async printEvent(batchData) {
      let loadingInstance = loadingService()
      this.editorValue = await batchPrint(batchData, this.selTemplate)
      this.$emit("dealLast")
      loadingInstance.close()
      await this.$nextTick()
      this.$refs.tinymce.preview()
    },
    // 当前选中项改变
    handleCurrentChange(val) {
      if (val && val.id) this.selTemplate = val.id
    }
  }
}
</script>

<style lang="scss" scoped>
.select-print-template {
  .empty {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: #c0c4cc;
  }
  ::v-deep .el-dialog__body {
    .el-table__row {
      cursor: pointer;
    }
    .circular {
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 100%;
      display: inline-block;
      width: 14px;
      height: 14px;
      &::after {
        content: "";
        transform: translate(-50%, -50%) scale(0);
      }
    }
    .active {
      position: relative;
      border-color: #409eff;
      background: #409eff;
      &:after {
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: #fff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(1);
        transition: transform 0.15s ease-in;
      }
    }
  }
  .tinymce {
    display: none;
    /*position: fixed;*/
    /*top: 9999px;*/
    /*left: 9999px;*/
  }
}
</style>
